import React, { useEffect, useState } from "react";
import { Modal } from "@mantine/core";
import ModalHeader from "components/ModalHeader";
import EditFormUser from "./editform";

interface UserData {
  userId: {
    firstName: string;
    lastName: string;
    email: string;
    role: string;
    _id: string;
  };
  role: string;
  permissions?: Record<string, Record<string, boolean>>;
}

type AddClientModalProps = {
  opened: boolean;
  onClose: () => void;
  user: UserData;
};

function EditUserModal({ opened, onClose, user }: AddClientModalProps) {
  useEffect(() => {
    console.log("data of the user coming from the parent screen is:", user);
  }, [user]);
  console.log("data of the user coming from the parent screen is:", user);
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      overlayOpacity={0.5}
      shadow="xs"
      size="xl"
      withCloseButton={false}
      transitionDuration={300}
      centered
    >
      <ModalHeader
        title="Edit User"
        onClose={onClose}
        ariaLabel="Close edit user modal"
      />
      <EditFormUser userData={user} onClose={onClose} />
    </Modal>
  );
}

export default EditUserModal;
